import React from "react";
import { Link } from "react-router-dom";
import { Layout } from "antd";
import { useSelector } from "react-redux";
import NewHeader from "../component/dashboard/NewGCRHeader";

function HeaderCompo({ initialColor }) {
  const { userAuth } = useSelector((state) => state.userAuth);
  const _useritems = [
    {
      label: <Link to="/users">Users</Link>,
      key: "5",
    },
    {
      label: <Link to="/accounts">Accounts</Link>,
      key: "6",
    },
  ];

  // console.log("userAuth-----", userAuth?.data?.user_roles_id, _useritems);

  return (
    <Layout style={{ backgroundColor: "white" }}>
      <NewHeader userAuth={userAuth} initialColor={initialColor} />
    </Layout>
  );
}

export default HeaderCompo;
